<template>
    <div>
        <b-button
            v-b-modal.filterModal
            variant="outline-secondary"
            v-b-tooltip.hover.left
            title="Filtrar dashboard por fecha"
        >
            <b-icon icon="calendar2-plus" font-scale="1"></b-icon>
        </b-button>

        <!-- Modal -->
        <b-modal id="filterModal" title="Filtro por fecha" class="" size="sm" centered
            header-bg-variant="dark" v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo del modal -->
            <DashboardFilterCalendar @closeModalParentEvent="closeModalParentEventHandler"></DashboardFilterCalendar>

        </b-modal>
    </div>
</template>
<script>
import DashboardFilterCalendar from '@/components/home/DashboardFilter/DashboardFilter-calendar.vue'

export default {
    name: 'DashboardFilter',

    data() {
        return {
            modalShow: false
        }
    },

    components: {
        DashboardFilterCalendar
    },

    methods:{
        closeModalParentEventHandler(){
            this.closeModal();
        },

        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },
    }

}
</script>
<style scoped>
.card {
    position: relative;
    width: auto;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    padding: 12px;
    gap: 12px;
    border-radius: 8px;
    cursor: pointer;
    margin: 20px;
}
</style>
